import { apiClient } from "../client";
const ENDPOINTS = {
    PARAMETERS: "/cost-parameters",
    GROUPS: "/cost-parameters/groups",
};
export const costsService = {
    // Get all cost parameter groups
    getGroups: () => apiClient.get(ENDPOINTS.GROUPS),
    // Get parameters by group
    getParametersByGroup: (groupId) => apiClient.get(`${ENDPOINTS.PARAMETERS}?groupId=${groupId}`),
    // Update a single cost parameter
    updateParameter: (id, data) => apiClient.patch(`${ENDPOINTS.PARAMETERS}/${id}`, data),
    // Delete a cost parameter
    deleteParameter: (id) => apiClient.delete(`${ENDPOINTS.PARAMETERS}/${id}`),
    // Bulk update cost parameters
    bulkUpdate: (updates) => apiClient.post(`${ENDPOINTS.PARAMETERS}/bulk`, { updates }),
    // Save all cost parameters for a group
    saveGroupParameters: (groupId, sections) => apiClient.put(`${ENDPOINTS.PARAMETERS}/groups/${groupId}`, { sections }),
};
